/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import Select from "react-select";
import PropTypes from "prop-types";
import SunEditor from "suneditor-react";
import { useDispatch } from "react-redux";
import COUNTRIES from "./allCountriesList";
import LANGUAGES from "./allLanguagesList";
import { Formik, Form, Field } from "formik";
import { getFormattedDate } from "../../helper/util";
// import { Country, State } from "country-state-city";
import {
  uploadLegalDoc,
  updateLegalDoc,
  fetchLegalDocs,
} from "../../redux/slice/legalDoc/legalAPI";
import "./styles.scss";
import "suneditor/dist/css/suneditor.min.css";

// All option for region
const allOption = { value: "all", label: "All" };

// Secret key for increption and decryption of data
const secretKey = "your-strong-secret-key";

const categoryOptions = [
  // Options for Category field
  { value: "PRIVACY POLICY", label: "Privacy Policy" },
  { value: "LEGAL DOCUMENT", label: "Legal Document" },
  { value: "GDPR", label: "GDPR" },
  { value: "HIPAA", label: "HIPAA" },
  { value: "TERM & CONDITIONS", label: "Term & Conditions" },
  { value: "OPTIONAL", label: "Optional" },
];

const editorOptions = {
  buttonList: [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["removeFormat"],
    ["outdent", "indent"],
    ["align", "horizontalRule", "list", "table"],
    ["link"],
    ["fullScreen", "codeView"],
  ],
};

function epochToDateString(epochTime) {
  // To convert epoch time to YYYY-MM-DD format
  const date = new Date(epochTime);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// function previousCountry(countryCode) {
//   // To fetch previous country while editing the document
//   const country = Country.getCountryByCode(countryCode);
//   return {
//     label: country.name,
//     value: country.isoCode,
//   };
// }

function previousCountry(countryCode) {
  // To fetch previous country while editing the document
  const country = COUNTRIES.filter((country) => country.iso2 === countryCode);
  return {
    label: country[0].name,
    value: country[0].iso2,
  };
}

// function previousState(countryCode, stateCodes) {
//   // To fetch previous states/regions while editing the document
//   const allStates = State.getStatesOfCountry(countryCode);
//   const formattedStates = allStates.map((item) => ({
//     label: item.name,
//     value: item.isoCode,
//   }));
//   const states = stateCodes.map((code) =>
//     formattedStates.find((option) => option.value === code)
//   );
//   if (states[0]) {
//     return states;
//   } else {
//     // If there are no states/regions and we have selected country in place of states
//     const country = Country.getCountryByCode(countryCode);
//     if (country) {
//       const formattedCountry = [
//         {
//           label: country.name,
//           value: country.isoCode,
//         },
//       ];
//       return formattedCountry;
//     }
//   }
// }

function previousState(countryCode, stateCodes) {
  // To fetch previous states/regions while editing the document
  if (countryCode) {
    const countryData = COUNTRIES.filter(
      (country) => country.iso2 === countryCode
    );
    const allStates = countryData[0].states;
    if (allStates[0]) {
      const formattedStates = allStates.map((item) => ({
        label: item.name,
        value: item.state_code,
      }));
      const states = stateCodes.map((code) =>
        formattedStates.find((option) => option.value === code)
      );
      return states;
    } else {
      //If there is no state in the coutry we will set country in dropdown
      const formattedCountry = [
        {
          label: countryData[0].name,
          value: countryData[0].isoCode,
        },
      ];
      return formattedCountry;
    }
  }
}

function decryptData(incryptedContent) {
  // TO decrypt the data
  const decryptedText = CryptoJS.AES.decrypt(
    incryptedContent,
    secretKey
  ).toString(CryptoJS.enc.Utf8);
  return decryptedText;
}

export default function LegalDocForm({
  data,
  isEdit,
  setShowLoader,
  goToDocumentList,
}) {
  const [docName, setDocName] = useState(isEdit && data?.name ? data.name : "");
  const [docDescription, setDocDescription] = useState(
    isEdit && data?.description ? data.description : ""
  );
  const [docCategory, setDocCategory] = useState(
    isEdit && data?.type
      ? categoryOptions.find((option) => option.value === data.type)
      : ""
  );
  const [docLanguage, setDocLanguage] = useState(
    isEdit && data?.language
      ? LANGUAGES.find((option) => option.value === data.language)
      : ""
  );
  const [docCountry, setDocCountry] = useState(
    isEdit && data?.country ? previousCountry(data.country) : ""
  );
  const [docRegion, setDocRegion] = useState(
    isEdit && data?.regions ? previousState(data.country, data.regions) : []
  );
  const [signatureValue, setSignatureValue] = useState(
    isEdit && data?.signatureRequired ? true : false
  );
  const [acceptanceValue, setAcceptanceValue] = useState(
    isEdit && data?.signatureRequired ? false : true
  );
  const [docApplicableDate, setDocApplicableDate] = useState(
    isEdit && data?.applicableFrom
      ? epochToDateString(data?.applicableFrom)
      : new Date().toISOString().split("T")[0]
  );
  const [docEndDate, setDocEndDate] = useState(
    isEdit && data?.applicableTo ? epochToDateString(data.applicableTo) : ""
  );
  const [selectedFromDate, setSelectedFromDate] = useState(
    isEdit && data?.applicableFrom
      ? epochToDateString(data.applicableFrom)
      : new Date().toISOString().split("T")[0]
  );
  const [allCountries, setAllCountries] = useState();
  const [filteredRegion, setFilteredRegion] = useState();
  const [selectedCountry, setSelectedCountry] = useState(
    isEdit && data?.country ? data.country : ""
  );
  const presentDate = new Date().toISOString().split("T")[0];
  const supportedFileTypes = [
    "application/pdf",
    "application/vnd.ms-word",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const [htmlShowData, setHtmlShowData] = useState(
    isEdit && data?.versionTrack?.length
      ? decryptData(data.versionTrack[data.versionTrack.length - 1].fileData)
      : ""
  );
  const [htmlError, setHtmlError] = useState(
    isEdit && data?.versionTrack?.length ? true : ""
  );
  const [fileError, setFileError] = useState("");
  const [fileBase64, setFileBase64] = useState("");
  const [docType, setDocType] = useState("HTML");
  const [fileExtension, setFileExtension] = useState("");
  const [fileContentType, setFileContentType] = useState("");
  const [docVersion, setDocVersion] = useState();
  const [versionOptions, setVersionOptions] = useState([]);

  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    // Form validations
    name: Yup.string()
      .matches(/^[a-zA-Z][a-zA-Z0-9_ -]*$/, "Invalid document name format")
      .required("Document name is required"),
    description: Yup.string()
      .required("Description is required")
      .max(500, "Description is limited up to 500 characters"),
    fileData: Yup.mixed().test(
      "fileSize",
      "File size must be less than 2MB",
      (value) => {
        if (!value) return true;
        return value.size <= 2 * 1024 * 1024;
      }
    ),
    type: Yup.string().required("Category is required"),
    language: Yup.string().required("Locale/Language is required"),
    country: Yup.string().required("Country is required"),
    regions: Yup.array()
      .of(Yup.string().required("Please select at least one region."))
      .min(1, "Please select at least one region."),
    signatureRequired: Yup.boolean(),
    acceptanceRequired: Yup.boolean(),
    startTime: Yup.number()
      .required("Start Time is required")
      .typeError("Start Time is required"),
  });

  const initialValues = {
    // Initial values of form input field
    base64: "",
    htmlData: "",
    contentType: "",
    fileExtension: "",
    userId: "user123",
    orgId: "ROOT",
    startTime:
      isEdit && data?.applicableFrom
        ? data.applicableFrom
        : new Date().getTime(),
    type: isEdit && data?.type ? data.type : "",
    name: isEdit && data?.name ? data.name : "",
    regions: isEdit && data?.regions ? data.regions : "",
    country: isEdit && data?.country ? data.country : "",
    language: isEdit && data?.language ? data.language : "",
    signatureRequired:
      isEdit && data?.signatureRequired ? true : signatureValue,
    acceptanceRequired:
      isEdit && data?.signatureRequired ? false : acceptanceValue,
    endTime: isEdit && data?.applicableTo ? data.applicableTo : 0,
    description: isEdit && data?.description ? data.description : "",
    editorData:
      isEdit && data?.versionTrack?.length
        ? decryptData(data.versionTrack[data.versionTrack.length - 1].fileData)
        : "",
  };

  // useEffect(() => {
  //   // To set countries in dropdown
  //   const countries = Country.getAllCountries();
  //   const formattedCountries = countries.map((item) => ({
  //     label: item.name,
  //     value: item.isoCode,
  //   }));
  //   setAllCountries(formattedCountries);
  // }, []);

  useEffect(() => {
    // To set countries in dropdown
    const formattedCountries = COUNTRIES.map((item) => ({
      label: item.name,
      value: item.iso2,
    }));
    setAllCountries(formattedCountries);
  }, []);

  // useEffect(() => {
  //   // To set states/regions in dropdown on the basis of selected country
  //   const states = State.getStatesOfCountry(selectedCountry);
  //   const formattedStates = states.map((item) => ({
  //     label: item.name,
  //     value: item.isoCode,
  //   }));
  //   if (formattedStates[0]) {
  //     setFilteredRegion([allOption, ...formattedStates]);
  //   } else {
  //     //If there is no state in the coutry we will set country in dropdown
  //     const country = Country.getCountryByCode(selectedCountry);
  //     if (country) {
  //       const formattedCountry = [
  //         {
  //           label: country.name,
  //           value: country.isoCode,
  //         },
  //       ];
  //       setFilteredRegion(formattedCountry);
  //     }
  //   }
  // }, [selectedCountry]);

  useEffect(() => {
    // To set states/regions in dropdown on the basis of selected country
    if (selectedCountry) {
      const countryData = COUNTRIES.filter(
        (country) => country.iso2 === selectedCountry
      );
      const states = countryData[0].states;
      if (states[0]) {
        const formattedStates = states.map((item) => ({
          label: item.name,
          value: item.state_code,
        }));
        setFilteredRegion([allOption, ...formattedStates]);
      } else {
        //If there is no state in the coutry we will set country in dropdown
        const formattedCountry = [
          {
            label: countryData[0].name,
            value: countryData[0].iso2,
          },
        ];
        setFilteredRegion(formattedCountry);
      }
    }
  }, [selectedCountry]);

  const handleEndDate = (startDate, setFieldValue) => {
    // To change the applicableTo date automatically on behalf of applicableFrom date
    if (Date.parse(startDate) > Date.parse(docEndDate)) {
      setDocEndDate(startDate);
      setFieldValue("endTime", Date.parse(startDate));
    }
  };

  function handleFileChange(event) {
    // To convert file into base64 and extract file type and file extension
    const file = event?.target?.files[0];
    if (!file) {
      return;
    }
    setFileContentType(file.type);
    setFileExtension(file.name.split(".").pop().toLowerCase());
    return new Promise((resolve, reject) => {
      if (!file) {
        reject(new Error("No file provided"));
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        setFileBase64(base64String);
        resolve(base64String);
      };
      reader.onerror = reject;
    });
  }

  useEffect(() => {
    const setOptions = () => {
      // To set the versionID options for the document
      const options = [];
      const sortedVersionArray = data.versionTrack.sort(
        (a, b) => b.modifiedDate - a.modifiedDate
      );
      sortedVersionArray.map((el, i) =>
        options.push({
          value: el.versionId,
          label: `Version ${sortedVersionArray.length - i} - ${getFormattedDate(
            el.modifiedDate
          )}`,
        })
      );
      setVersionOptions(options);
      const defaultVersion = options[0];
      setDocVersion(defaultVersion);
    };
    if (isEdit) {
      setOptions();
    }
  }, []);

  function handleVersionChange(event) {
    // When we change the document version
    setDocVersion(event);
    const doc = data.versionTrack.filter((el) => el.versionId === event.value);
    setDocApplicableDate(epochToDateString(doc[0].applicableFrom));
    setDocEndDate(
      doc[0].applicableTo ? epochToDateString(doc[0].applicableTo) : ""
    );
    setHtmlShowData(decryptData(doc[0].fileData));
  }

  function handleRegionChange(event, action, setFieldValue) {
    // When region/state is changed
    if (action?.removedValue?.value === "all") {
      setDocRegion([]);
      setFieldValue("regions", []);
      return;
    }
    if (action?.option?.value === "all") {
      if (action?.action === "select-option") {
        const regions = filteredRegion.filter((reg) => reg.value !== "all");
        const arr = [];
        setDocRegion(filteredRegion);
        for (const item in regions) {
          arr.push(regions[item].value);
        }
        setFieldValue("regions", arr);
      } else {
        setDocRegion([]);
        setFieldValue("regions", []);
      }
    } else {
      const regions = event.filter((reg) => reg.value !== "all");
      const arr = [];
      setDocRegion(regions);
      for (const item in regions) {
        arr.push(regions[item].value);
      }
      setFieldValue("regions", arr);
    }
  }

  function convertDate(dateString) {
    // To get minimum Applicable to date
    const date = new Date(dateString);
    const epoch = date.getTime();
    const epochPlus24Hours = epoch + 24 * 60 * 60 * 1000;
    const newDate = new Date(epochPlus24Hours);
    const formattedDate = newDate.toISOString().slice(0, 10);
    return formattedDate;
  }

  const handleSubmit = (values) => {
    // On click of submit button
    if (
      (docType === "HTML" && !htmlError) ||
      (docType === "HTML" && htmlError === "<p><br></p>")
    ) {
      return;
    }
    if (docType === "DOCUMENT" && !fileError) {
      return;
    }
    const payload = { ...values };
    const params = {
      orgId: "ROOT",
    };
    if (payload?.signatureRequired) {
      delete payload["acceptanceRequired"];
    }
    if (payload?.acceptanceRequired) {
      delete payload["signatureRequired"];
    }
    if (isNaN(payload?.endTime)) {
      payload["endTime"] = 0;
    }
    if (docType === "DOCUMENT") {
      delete payload["htmlData"];
      payload["base64"] = fileBase64;
      payload["contentType"] = fileContentType;
      payload["fileExtension"] = fileExtension;
    }
    if (docType === "HTML") {
      // To incrypt the data
      const incryptedContent = CryptoJS.AES.encrypt(
        htmlShowData,
        secretKey
      ).toString();
      delete payload["base64"];
      delete payload["contentType"];
      delete payload["fileExtension"];
      payload["htmlData"] = incryptedContent;
    }
    delete payload["fileData"];
    delete payload["editorData"];

    if (isEdit) {
      // When we try to update the document
      setShowLoader(true);
      delete payload["name"];
      delete payload["type"];
      delete payload["language"];
      payload["documentId"] = data.sk;
      dispatch(updateLegalDoc(payload))
        .then((response) => {
          setShowLoader(false);
          if (response?.data?.success) {
            dispatch(fetchLegalDocs(params));
            goToDocumentList();
            Swal.fire({
              title: response?.data?.message,
              icon: "success",
            });
          } else {
            Swal.fire({
              title: response?.data?.message
                ? response?.data.message
                : "Something went wrong",
              icon: "error",
            });
          }
        })
        .catch((error) => {
          setShowLoader(false);
          Swal.fire({
            title: error?.message ? error.message : "Something went wrong",
            icon: "error",
          });
        });
    } else {
      // When we try to create a new document
      setShowLoader(true);
      dispatch(uploadLegalDoc(payload))
        .then((response) => {
          setShowLoader(false);
          if (response?.data?.success) {
            dispatch(fetchLegalDocs(params));
            goToDocumentList();
            Swal.fire({
              title: response?.data?.message,
              icon: "success",
            });
          } else {
            Swal.fire({
              title: response?.data?.message
                ? response?.data.message
                : "Something went wrong",
              icon: "error",
            });
          }
        })
        .catch((error) => {
          setShowLoader(false);
          Swal.fire({
            title: error?.message ? error.message : "Something went wrong",
            icon: "error",
          });
        });
    }
  };

  return (
    <div className='createFormMeaasge updateDoc'>
      <h3>{isEdit ? "Update Document" : "Upload Document"}</h3>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, setFieldValue, submitCount, dirty }) => (
          <Form>
            {/* Document Name */}
            <div className='form-group pt-3'>
              <div className='labelOf'>Document Name</div>
              <Field
                type='text'
                value={docName}
                disabled={isEdit}
                name='documentName'
                placeholder='Document Name'
                onChange={(event) => {
                  setDocName(event.target.value.trimStart());
                  setFieldValue("name", event.target.value.trimStart());
                }}
              />
              <span style={{ color: "red" }}>
                {errors && submitCount && errors.name ? errors.name : ""}
              </span>
            </div>
            {/* Document Description */}
            <div className='form-group'>
              <div className='labelOf'>Document Description</div>
              <Field
                rows='5'
                cols='50'
                as='textarea'
                id='Description'
                name='description'
                placeholder='Description'
                value={docDescription}
                onChange={(event) => {
                  setDocDescription(event.target.value.trimStart());
                  setFieldValue("description", event.target.value.trimStart());
                }}
              />
              <span style={{ color: "red" }}>
                {errors && submitCount && errors.description
                  ? errors.description
                  : ""}
              </span>
            </div>
            {/* Select Version Dropdown */}
            {isEdit && (
              <div className='form-group'>
                <label>Change Document Version</label>
                <Select
                  className='indexClass'
                  value={docVersion}
                  // defaultValue={docVersion}
                  options={versionOptions}
                  placeholder='Select Version'
                  backspaceRemovesValue={false}
                  onChange={(event) => handleVersionChange(event)}
                />
              </div>
            )}
            {/* Document type radio button */}
            <div className='form-group'>
              <div className='labelOf'>Document Type</div>
              <div className='d-flex'>
                {/* <label className='d-flex gap-1'>
                  <input
                    type='radio'
                    id='typeDoc'
                    name='doc_type'
                    value='DOCUMENT'
                    checked={docType === "DOCUMENT"}
                    onChange={() => {
                      setHtmlShowData("");
                      setFileError(false);
                      setDocType("DOCUMENT");
                      setFieldValue("htmlData", "");
                    }}
                  />
                  DOCUMENT
                </label> */}
                <label className='d-flex gap-1 px-2'>
                  <input
                    value='HTML'
                    type='radio'
                    id='typeHTML'
                    name='doc_type'
                    checked={docType === "HTML"}
                    onChange={() => {
                      setDocType("HTML");
                      setHtmlError(false);
                      setFieldValue("fileData", "");
                    }}
                  />
                  HTML
                </label>
              </div>
            </div>
            {docType === "HTML" && (
              <div className='form-group'>
                {/* TEXT EDITOR - ADD HTML */}
                <SunEditor
                  onChange={(content) => {
                    setHtmlShowData(content);
                    setHtmlError(content);
                    setFieldValue("editorData", content);
                  }}
                  setContents={htmlShowData}
                  // defaultValue={htmlShowData}
                  setOptions={editorOptions}
                />
                <span className='error'>
                  {submitCount > 0
                    ? !htmlError || htmlError === "<p><br></p>"
                      ? "Content is required"
                      : ""
                    : ""}
                </span>
              </div>
            )}
            {/* Upload File */}
            {docType === "DOCUMENT" && (
              <div className='form-group btnChoose'>
                <input
                  id='file'
                  name='file'
                  type='file'
                  onChange={(event) => {
                    handleFileChange(event);
                    setFieldValue("fileData", event?.target?.files[0]);
                    setFileError(event?.target?.files[0]);
                  }}
                  accept={supportedFileTypes.join(",")}
                />
                <span className='error'>
                  {submitCount > 0
                    ? fileError
                      ? ""
                      : "File is required."
                    : ""}
                </span>
                <span style={{ color: "red" }}>
                  {errors && submitCount && errors.fileData
                    ? errors.fileData
                    : ""}
                </span>
              </div>
            )}
            {/* Category */}
            <div className='form-group'>
              <label>Category</label>
              <Select
                isDisabled={isEdit}
                value={docCategory}
                options={categoryOptions}
                placeholder='Select Category'
                onChange={(event) => {
                  setDocCategory(event);
                  setFieldValue("type", event.value);
                }}
              />
              <span style={{ color: "red" }}>
                {errors && errors.type && submitCount ? errors.type : ""}
              </span>
            </div>
            {/* Locale/Language */}
            <div className='form-group'>
              <label>Locale/Language</label>
              <Select
                isDisabled={isEdit}
                value={docLanguage}
                options={LANGUAGES}
                placeholder='Select Locale/Language'
                onChange={(event) => {
                  setDocLanguage(event);
                  setFieldValue("language", event.value);
                }}
              />
              <span style={{ color: "red" }}>
                {errors && errors.language && submitCount
                  ? errors.language
                  : ""}
              </span>
            </div>
            {/* Country */}
            <div className='form-group'>
              <label>Country</label>
              <Select
                value={docCountry}
                options={allCountries}
                placeholder='Select Country'
                onChange={(event) => {
                  setDocRegion([]);
                  setDocCountry(event);
                  setFieldValue("regions", []);
                  setSelectedCountry(event.value);
                  setFieldValue("country", event.value);
                }}
              />
              <span style={{ color: "red" }}>
                {errors && errors.country && submitCount ? errors.country : ""}
              </span>
            </div>
            {/* Region */}
            <div className='form-group'>
              <label>Region</label>
              <Select
                isMulti
                value={docRegion}
                options={filteredRegion}
                closeMenuOnSelect={false}
                placeholder='Select Region'
                // hideSelectedOptions={false}
                isDisabled={!selectedCountry}
                backspaceRemovesValue={false}
                onChange={(event, action) =>
                  handleRegionChange(event, action, setFieldValue)
                }
              />
              <span style={{ color: "red" }}>
                {errors && errors.regions && submitCount ? errors.regions : ""}
              </span>
            </div>
            {/* Signature radio button */}
            <div className='form-group'>
              <div className='labelOf'>Signature Required</div>
              <div className='d-flex'>
                <label className='d-flex gap-1'>
                  <input
                    type='radio'
                    value='true'
                    id='signYes'
                    checked={signatureValue}
                    name='signature_required'
                    onChange={() => {
                      setSignatureValue(true);
                      setAcceptanceValue(false);
                      setFieldValue("signatureRequired", true);
                      setFieldValue("acceptanceRequired", false);
                    }}
                  />
                  Yes
                </label>
                <label className='d-flex gap-1 px-2'>
                  <input
                    id='signNo'
                    type='radio'
                    value='false'
                    name='signature_required'
                    checked={!signatureValue}
                    onChange={() => {
                      setSignatureValue(false);
                      setAcceptanceValue(true);
                      setFieldValue("signatureRequired", false);
                      setFieldValue("acceptanceRequired", true);
                    }}
                  />
                  No
                </label>
              </div>
              <span style={{ color: "red" }}>
                {errors && errors.signatureRequired && submitCount
                  ? errors.signatureRequired
                  : ""}
              </span>
            </div>
            {/* Acceptance Required radio button*/}
            <div className='form-group'>
              <div className='labelOf'>Acceptance Required</div>
              <div className='d-flex'>
                <label className='d-flex gap-1'>
                  <input
                    type='radio'
                    value='true'
                    id='acceptYes'
                    checked={acceptanceValue}
                    name='acceptance_required'
                    onChange={() => {
                      setSignatureValue(false);
                      setAcceptanceValue(true);
                      setFieldValue("acceptanceRequired", true);
                      setFieldValue("signatureRequired", false);
                    }}
                  />
                  Yes
                </label>
                <label className='d-flex gap-1 px-2'>
                  <input
                    type='radio'
                    id='acceptNo'
                    value='false'
                    name='acceptance_required'
                    checked={!acceptanceValue}
                    onChange={() => {
                      setSignatureValue(true);
                      setAcceptanceValue(false);
                      setFieldValue("signatureRequired", true);
                      setFieldValue("acceptanceRequired", false);
                    }}
                  />
                  No
                </label>
              </div>
              <span style={{ color: "red" }}>
                {errors && errors.acceptanceRequired && submitCount
                  ? errors.acceptanceRequired
                  : ""}
              </span>
            </div>
            {/* Applicable From */}
            <div className='form-group dateInput'>
              <label>Applicable From</label>
              <input
                id='date'
                type='date'
                min={presentDate}
                value={docApplicableDate}
                onChange={(event) => {
                  setSelectedFromDate(event.target.value);
                  setDocApplicableDate(event.target.value);
                  handleEndDate(event.target.value, setFieldValue);
                  setFieldValue("startTime", Date.parse(event.target.value));
                }}
              />
              <span style={{ color: "red" }}>
                {errors && errors.startTime && submitCount
                  ? errors.startTime
                  : ""}
              </span>
            </div>
            {/* Applicable To */}
            <div className='form-group dateInput'>
              <label>Applicable To</label>
              <input
                id='date'
                type='date'
                min={convertDate(selectedFromDate)}
                disabled={!selectedFromDate}
                value={docEndDate && docEndDate}
                onChange={(event) => {
                  setDocEndDate(event.target.value);
                  setFieldValue("endTime", Date.parse(event.target.value));
                }}
              />
            </div>
            <div className='d-flex gap-5'>
              <button
                type='cancle'
                className='cancleBtn'
                onClick={goToDocumentList}
              >
                Cancel
              </button>
              <button
                type='submit'
                className={!dirty ? "btnDisable" : ""}
                disabled={!dirty}
              >
                {isEdit ? "Update" : "Submit"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

LegalDocForm.defaultProps = {
  isEdit: false,
  editDocData: {},
};

LegalDocForm.propTypes = {
  isEdit: PropTypes.bool,
  editDocData: PropTypes.object,
  setShowLoader: PropTypes.func,
  goToDocumentList: PropTypes.func,
};
